module.exports = __webpack_public_path__ + "img/photo-0080.ccbe285e.jpg";